// src/api/mockData.js
export const defaultAboutInfoTemplate = {
  name: '高永涛',
  avatar: 'https://tse4-mm.cn.bing.net/th/id/OIP-C.AMtPC6PDOeHld1jXqk4OWQHaHa?w=203&h=204&c=7&r=0&o=5&dpr=1.3&pid=1.7',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: '3199929527@qq.com', 
  techStack: '暂无',
  interests: '羽毛球、模型拼装',
  github: '#',
  linkedin: '#',
  personalHomepage: '#',
};

// 模拟博客文章数据
export let blogPosts = [
  {
    id: 1,
    title: 'React入门指南',
    excerpt: 'React是一个用于构建用户界面的JavaScript库。它由Facebook开发，是一个非常流行的前端框架。',
    content: 'React是一个用于构建用户界面的JavaScript库。它由Facebook开发，是一个非常流行的前端框架。React的核心思想是组件化，通过将UI拆分成独立的组件，使开发变得更加简单和可维护。',
    author: '高永涛',
    date: '2024-12-20',
    tags: ['React', '前端', 'JavaScript'],
    readTime: '5分钟阅读'
  },
  {
    id: 2,
    title: 'Ant Design使用技巧',
    excerpt: 'Ant Design是企业级UI设计语言和React组件库，它提供了丰富的组件和设计模式。',
    content: 'Ant Design是企业级UI设计语言和React组件库，它提供了丰富的组件和设计模式。使用Ant Design可以快速构建美观且功能强大的企业级应用。',
    author: '高永涛',
    date: '2024-12-18',
    tags: ['Ant Design', 'UI', 'React'],
    readTime: '8分钟阅读'
  },
  {
    id: 3,
    title: '前端开发最佳实践',
    excerpt: '在现代前端开发中，有许多最佳实践可以帮助我们编写更高效、更可维护的代码。',
    content: '在现代前端开发中，有很多最佳实践可以帮助我们编写更高效、更可维护的代码。包括组件化设计、状态管理、性能优化等方面。',
    author: '高永涛',
    date: '2024-12-15',
    tags: ['前端', '最佳实践', '开发'],
    readTime: '10分钟阅读'
  },
  {
    id: 4,
    title: 'JavaScript ES6新特性详解',
    excerpt: 'ES6（ECMAScript 2015）引入了许多新特性，大大提高了JavaScript的开发效率。',
    content: 'ES6（ECMAScript 2015）引入了许多新特性，如箭头函数、解构赋值、模板字符串、类等，大大提高了JavaScript的开发效率和代码可读性。',
    author: '高永涛',
    date: '2024-12-10',
    tags: ['JavaScript', 'ES6', '前端'],
    readTime: '12分钟阅读'
  }
];

// 添加新文章的函数
export const addBlogPost = (postData) => {
  const newPost = {
    id: Math.max(...blogPosts.map(p => p.id)) + 1, // 生成新ID
    title: postData.title,
    excerpt: postData.excerpt,
    content: postData.content,
    author: '当前用户', // 使用当前登录用户
    date: new Date().toISOString().split('T')[0], // 使用当前日期
    tags: postData.tags || [],
    readTime: postData.content ? `${Math.ceil(postData.content.length / 800)}分钟阅读` : '1分钟阅读'
  };
  blogPosts.push(newPost);
  return newPost;
};

// 删除文章的函数
export const deleteBlogPost = (postId) => {
  const index = blogPosts.findIndex(post => post.id === postId);
  if (index !== -1) {
    blogPosts.splice(index, 1);
    return true;
  }
  return false;
};